export const REGIONS_AND_COUNTRIES = 'REGIONS_AND_COUNTRIES'

export const ERROR_STATE = 'ERROR_STATE'
